"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandButton = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _getClassesPropType = require("../../helpers/getClassesPropType");

var _useStyles = require("../../helpers/useStyles");

var _classnames = _interopRequireDefault(require("classnames"));

var _SvgInSelectArrow = require("../svg/interface/SvgInSelectArrow");

var _SvgInPlusFat = require("../svg/interface/SvgInPlusFat");

var _SvgInClose = require("../svg/interface/SvgInClose");

var _SvgInCloseThin = require("../svg/interface/SvgInCloseThin");

var _SvgInSearch = require("../svg/interface/SvgInSearch");

var _loadStyles = _interopRequireDefault(require("load-styles"));

var _excluded = ["children", "view", "size", "classes"];
(0, _loadStyles.default)(".ca2f3ee4c{outline:0;background:0 0;border:0;color:inherit;font:inherit;line-height:normal;overflow:visible;padding:0;-webkit-user-select:none;-ms-user-select:none;user-select:none;max-width:100%;cursor:pointer;display:inline-flex;align-items:center;color:var(--color-flomni-blue-70)}.ca2f3ee4c:hover{opacity:.7}.ca2f3ee4c:active{opacity:.5}.cbd039b1a{white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.cbd039b1a::first-letter{text-transform:uppercase}.c259dfb72{flex-shrink:0;display:flex;align-items:center}.c371f1f22{font-size:.875rem;font-weight:500;line-height:1rem}.cd825b659{font-size:1rem;font-weight:500;line-height:1.125rem}.cb1a4f614 .c259dfb72{margin-left:.4375rem;width:.625rem}.cb1a4f614 .c68a0214a,.cb1a4f614 .c706964c7,.cb1a4f614 .ca3b807f4,.cb1a4f614 .cc3d9876d{display:none}.c8319d613 .c259dfb72{margin-right:.4375rem;width:.5625rem;max-height:.875rem}.c8319d613 .c08328f54,.c8319d613 .c706964c7,.c8319d613 .ca3b807f4,.c8319d613 .cc3d9876d{display:none}.cfc9c1a51 .c259dfb72{margin-left:.4375rem;width:.625rem;max-height:.875rem}.cfc9c1a51 .c08328f54,.cfc9c1a51 .c68a0214a,.cfc9c1a51 .ca3b807f4,.cfc9c1a51 .cc3d9876d{display:none}.c0b5c9fad .c259dfb72{margin-left:.4375rem;width:1rem;max-height:.875rem}.c0b5c9fad .c08328f54,.c0b5c9fad .c68a0214a,.c0b5c9fad .c706964c7,.c0b5c9fad .ca3b807f4{display:none}.c8b6264f7 .c259dfb72{margin-left:.4375rem;max-height:.875rem}.c8b6264f7 .c08328f54,.c8b6264f7 .c68a0214a,.c8b6264f7 .c706964c7,.c8b6264f7 .cc3d9876d{display:none}");
var styles = {
  root: 'ca2f3ee4c',
  children: 'cbd039b1a',
  icon: 'c259dfb72',
  '--size-small': 'c371f1f22',
  '--size-usual': 'cd825b659',
  '--view-action': 'cb1a4f614',
  plus: 'c68a0214a',
  close: 'c706964c7',
  search: 'cc3d9876d',
  closeThin: 'ca3b807f4',
  '--view-plus': 'c8319d613',
  arrow: 'c08328f54',
  '--view-close': 'cfc9c1a51',
  '--view-search': 'c0b5c9fad',
  '--view-closeThin': 'c8b6264f7'
};

var ExpandButton = function ExpandButton(props) {
  var children = props.children,
      view = props.view,
      size = props.size,
      classes = props.classes,
      rest = (0, _objectWithoutProperties2.default)(props, _excluded);
  var cn = (0, _useStyles.useStyles)(styles, classes);
  return /*#__PURE__*/_react.default.createElement("button", (0, _extends2.default)({
    className: (0, _classnames.default)(cn.root, cn.view[view], cn.size[size])
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.icon, cn.plus)
  }, /*#__PURE__*/_react.default.createElement(_SvgInPlusFat.SvgInPlusFat, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: cn.children
  }, children), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.icon, cn.arrow)
  }, /*#__PURE__*/_react.default.createElement(_SvgInSelectArrow.SvgInSelectArrow, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.icon, cn.close)
  }, /*#__PURE__*/_react.default.createElement(_SvgInClose.SvgInClose, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.icon, cn.closeThin)
  }, /*#__PURE__*/_react.default.createElement(_SvgInCloseThin.SvgInCloseThin, null)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(cn.icon, cn.search)
  }, /*#__PURE__*/_react.default.createElement(_SvgInSearch.SvgInSearch, null)));
};

exports.ExpandButton = ExpandButton;
var view = ['action', 'plus', 'close', 'closeThin', 'search'];
var size = ['usual', 'small'];
ExpandButton.modes = {
  view: view,
  size: size
};
ExpandButton.propTypes = {
  /* component logic props */
  children: _propTypes.node.isRequired,

  /* styling modificators */
  view: (0, _propTypes.oneOf)(view),
  size: (0, _propTypes.oneOf)(size),

  /* classes */
  classes: (0, _getClassesPropType.getClassesPropType)(styles)
};
ExpandButton.defaultProps = {
  view: 'action',
  size: 'usual',
  classes: {}
};